import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, Input } from '@angular/core';
import { MatAccordionDisplayMode } from '@angular/material/expansion';
import { ADPResourceService } from 'digital-core';
import { IFaq, IFaqListItemKeys } from 'src/app/model/sitefinity/IFaq';

@Component({
  selector: 'pgh-claims-suppport-faq',
  templateUrl: './claims-suppport-faq.component.html',
  styleUrls: ['./claims-suppport-faq.component.scss'],
})
export class ClaimsSupportFaqComponent implements OnInit {
  @Input() displayMode: MatAccordionDisplayMode;
  @Input() faq: IFaq;
  @Input() faqListItems: IFaqListItemKeys[];

  currentlyOpenedItemIndex = -1;
  faqImageUrl: string = '';
  faqImageAltText: string = '';

  constructor(
    private breakpointObserver: BreakpointObserver,
    private resourceService: ADPResourceService
  ) {}

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
      if (result.matches) {
        this.faqImageUrl = this.resourceService.getPortalImage('Global_FAQ_Mobile').ImageURL;
        this.faqImageAltText = this.resourceService.getPortalImage('Global_FAQ_Mobile').Caption;
      } else {
        this.faqImageUrl = this.resourceService.getPortalImage('Global_FAQ').ImageURL;
        this.faqImageAltText = this.resourceService.getPortalImage('Global_FAQ').Caption;
      }
    });
  }

  setOpened(itemIndex: number) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex: number) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
